import request from '@/utils/request'

export function alarmList(params) {
  return request({
    url: `/api/alarm`,
    method: 'get',
    params
  })
}

export function alarmSuccess(id) {
  return request({
    url: `/api/alarm/${id}`,
    method: 'put'
  })
}

export function alarmCount() {
  return request({
    url: '/api/alarm/count',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/alarm.js